import './NotifyModal.css'
import { BodyBlocker } from './BodyBlocker'
import { useTranslation } from 'react-i18next'

export function NotifyModal({ text, onClose }: { text: string; onClose: () => void }) {
  const { t } = useTranslation()
  return (
    <div className="notify-backdrop" onClick={onClose}>
      <div className="notify-window" onClick={(e) => e.stopPropagation()}>
        <BodyBlocker />
        <div className="notify-text">{text}</div>
        <button className="notify-button" onPointerUp={onClose}>
          {t('ok')}
        </button>
      </div>
    </div>
  )
}
